/* eslint-disable react/prop-types */
import React from "react";
import { SectionContainer } from "@silversea-ssc/ui-components-react";
import CruiseSummary, { CruiseSummaryProps } from "./CruiseSummary";
import { dequal } from "dequal/lite";
import StickyMenu, { StickyMenuProps } from "components/StickyMenu/StickyMenu";

type StickyCruiseMenuProps = Omit<StickyMenuProps, "backgroundColor"> & {
  summary: CruiseSummaryProps;
};

const StickyCruiseMenuNew: React.FC<
  React.PropsWithChildren<StickyCruiseMenuProps>
> = ({ summary, ...menuProps }) => {
  return (
    <StickyMenu {...menuProps} backgroundColor="white">
      <SectionContainer backgroundColor="white">
        <CruiseSummary {...summary} />
      </SectionContainer>
    </StickyMenu>
  );
};

export default React.memo(StickyCruiseMenuNew, dequal);
